module.exports = __webpack_public_path__ + "img/upload.67cafa41.png";